









import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatFileSize } from '@/utils/helper';
import { IOssDownloadList } from '@/store/home/stats/types';
import DataTable from '../../common/DataTable.vue';

const Stats = namespace('home/stats');

@Component({
  components: { DataTable },
})
export default class OssDownloadTable extends Vue {
  @Stats.State('ossDownloadList') public list!: IOssDownloadList;

  public headers = [
    { text: '组织', value: 'orgName' },
    { text: '用户', value: 'userName' },
    { text: '总次数', value: 'totalCount' },
    { text: '总体积', value: 'totalSize' },
  ];

  public get items() {
    return this.list.data.map((item) => {
      const totalSize = formatFileSize(item.totalSize);
      return { ...item, totalSize };
    });
  }
}
